import {isEmpty, isNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {SourcingTableName} from '../types/SourcingTableName';

function getIdKey(tableName: SourcingTableName) {
  return `sourcing-table--last-visited-vehicle-id/${tableName}`;
}

function getPageKey(tableName: SourcingTableName) {
  return `sourcing-table--last-visited-page/${tableName}`;
}

export const sourcingTableSessionStorage = {
  setLastVisitedVehicleId(tableName: SourcingTableName, adId: string) {
    sessionStorage.setItem(getIdKey(tableName), adId);
  },
  getLastVisitedVehicleId(tableName: SourcingTableName) {
    return sessionStorage.getItem(getIdKey(tableName)) || null;
  },
  setLastVisitedPage(tableName: SourcingTableName, page: number) {
    sessionStorage.setItem(getPageKey(tableName), page.toString());
  },
  getLastVisitedPage(tableName: SourcingTableName): number | null {
    const page = sessionStorage.getItem(getPageKey(tableName));
    return isNil(page) || isEmpty(page) ? null : parseInt(page);
  },
  setLastSelectedView(isDetailedView: boolean) {
    sessionStorage.setItem('sourcing-table--last-selected-view', isDetailedView.toString());
  },
  getLastSelectedView(): boolean {
    const view = sessionStorage.getItem('sourcing-table--last-selected-view');
    return isNilOrEmpty(view) ? false : view === 'true';
  },
  setIsRealTime(isRealTime: boolean) {
    sessionStorage.setItem('sourcing-table--is-real-time', isRealTime.toString());
  },
  getIsRealTime(): boolean {
    const isRealTime = sessionStorage.getItem('sourcing-table--is-real-time');
    return isNilOrEmpty(isRealTime) ? false : isRealTime === 'true';
  },
};
